import React, {FC, PropsWithChildren} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {DropdownItemIcon} from '../../../common/dropdowns/dropdownItemIcon';
import {DropdownItemSecondaryIcon} from '../../../common/dropdowns/dropdownItemSecondaryIcon';

/*
 * Props.
 */

export interface UserProfileDropdownItemProps extends DropdownItemProps {
  iconName?: IconName;
  isExternal?: boolean;
}

/*
 * Component.
 */

export const UserProfileDropdownItem: FC<PropsWithChildren<UserProfileDropdownItemProps>> = (props) => (
  <DropdownItem {...props}>
    {props.iconName && <DropdownItemIcon label={null} iconName={props.iconName} />}
    <DropdownItemContent isChecked={props.isChecked}>{props.children}</DropdownItemContent>
    {maybeRenderSecondaryIcon(props)}
  </DropdownItem>
);

function maybeRenderSecondaryIcon({isExternal, isChecked}: UserProfileDropdownItemProps) {
  if (!isExternal) {
    return null;
  }

  return (
    <UserThemeConsumer>
      {(theme) => (
        <DropdownItemSecondaryIcon
          label={<Trans id="userprofiledropdown-external">External link</Trans>}
          iconName="iconLinkSmall"
          color={theme.greys.shade60}
          isChecked={isChecked}
        />
      )}
    </UserThemeConsumer>
  );
}
